import { ROLES } from "@amber/contracts";
import { ROLE_DESCRIPTIONS, ROLE_LABELS } from "../../contracts/index";

export const ROLE_OPTIONS = ROLES.map((role) => ({
  value: role,
  label: ROLE_LABELS[role],
  description: ROLE_DESCRIPTIONS[role],
}));
